var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"height":"auto","padding-top":"1px !important"},attrs:{"id":"home","fluid":"","tag":"section"}})
}
var staticRenderFns = []

export { render, staticRenderFns }